import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Hauteur du Trapèze";
const DESCRIPTION =
  "Calculatrice Hauteur du Trapèze pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "hauteur du trapèze, calculatrice hauteur du trapèze, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/trapezoid-height";
function TrapezoidHeightCalculator() {
  const [area, setArea] = useState("");
  const [base1, setBase1] = useState("");
  const [base2, setBase2] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const a = parseFloat(area);
      const b1 = parseFloat(base1);
      const b2 = parseFloat(base2);
      if (isNaN(a) || isNaN(b1) || isNaN(b2)) {
        setError("Entrez toutes les valeurs");
        setResult("");
        return;
      }
      const height = (2 * a / (b1 + b2)).toFixed(2);
      setResult(height);
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Surface:</label>
                    <input
                      type="number"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Base 1:</label>
                    <input
                      type="number"
                      value={base1}
                      onChange={(e) => setBase1(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Base 2:</label>
                    <input
                      type="number"
                      value={base2}
                      onChange={(e) => setBase2(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer Hauteur
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Hauteur: {result}
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'un trapèze ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Un trapèze est un quadrilatère possédant deux côtés parallèles
                        appelés bases (grande base et petite base) et deux côtés non parallèles.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer la hauteur ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La hauteur d'un trapèze se calcule à partir de l'aire :
                        h = (2 × Aire) ÷ (base₁ + base₂).
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Exemples d'utilisation</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le trapèze est utilisé dans la conception de toits inclinés,
                        de ponts et de machines. Connaître le calcul de sa hauteur
                        garantit la précision et la stabilité des structures.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default TrapezoidHeightCalculator;
